import { render, staticRenderFns } from "./card-slot.vue?vue&type=template&id=57f2f4d4&"
import script from "./card-slot.vue?vue&type=script&lang=js&"
export * from "./card-slot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57f2f4d4')) {
      api.createRecord('57f2f4d4', component.options)
    } else {
      api.reload('57f2f4d4', component.options)
    }
    module.hot.accept("./card-slot.vue?vue&type=template&id=57f2f4d4&", function () {
      api.rerender('57f2f4d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/container/card-slot.vue"
export default component.exports